import React from "react";
import { Outlet } from "react-router-dom";

function ReportsComp() {
  return (
    <div>
      <Outlet />
    </div>
  );
}

export default ReportsComp;
